import { isStringQuery } from "src/utils/helpers/url/isStringQuery";

export const parseQueryPageNumber = (page?: string[] | string) => {
  if (isStringQuery(page)) {
    const splitPage = page.split("-");
    if (splitPage[0] === "page" && splitPage[1]) {
      return Number(splitPage[1]);
    }
  }
  return 1;
};

export const parseQueryPageNumberBrand = (page?: string[] | string) => {
  if (isStringQuery(page)) {
    const splitPage = page.split("-");
    if (splitPage[0] === "page" && splitPage[1]) {
      return Number(splitPage[1]);
    }
  }
  return null;
};
